import { Box, Stack } from "@mui/material";
import { TextInput, required } from "react-admin";

const Form = (prop: { isCreate: boolean }) => {
  const { isCreate } = prop;
  return (
    <Box sx={{ pt: 3, pb: 3 }}>
      <Stack>
        <TextInput
          disabled={!isCreate}
          source="key"
          label="module.prediction.system-configs.key"
          validate={[required()]}
        />
        <TextInput
          source="value"
          rows={10}
          multiline
          label="module.prediction.system-configs.value"
          validate={[required()]}
        />
      </Stack>
    </Box>
  );
};

export default Form;